import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import NoSearchResult from "../../../../components/Common/NoSearchResult";
import React, {useState} from "react";
import {useQuery} from "@tanstack/react-query";
import {ErrorClassifierService} from "../../../../services/error_classifier.service";
import ErrorKeyItem from "./ErrorKeyItem";
import ErrorKeyItemCreate from "./ErrorKeyItemCreate";

interface ModalErrorKeysProps {
    isOpen: boolean;
    onClose: () => void;
}

const ModalErrorKeys: React.FC<ModalErrorKeysProps> = ({isOpen, onClose}) => {
    const [isRemoveMode, setIsRemoveMode] = useState<boolean>(false)

    const {
        data: errorKeys,
        isFetching
    } = useQuery({
        queryKey: ["keyErrorClassifierErrorKeys"],
        queryFn: () => ErrorClassifierService.getErrorKeys()
    });

    const closeModal = () => {
        onClose();
    };

    return (
        <Modal isOpen={isOpen} toggle={closeModal}>
            <ModalHeader toggle={closeModal} tag="h4">
                Error Keys
            </ModalHeader>
            {isFetching ? <div className="my-4"><NoSearchResult text="Loading..."/></div> : (<>
                <ModalBody style={{minHeight: "60px"}}>
                    <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap">
                        {errorKeys?.map(errorKey => (
                            <ErrorKeyItem key={errorKey.id} id={errorKey.id} value={errorKey.name}
                                          isRemoveMode={isRemoveMode}/>
                        ))}
                    </div>
                </ModalBody>
                <ModalFooter className="align-items-center justify-content-between">
                    <Button color="danger" onClick={() => setIsRemoveMode(prev => !prev)}>
                        {isRemoveMode ? "Cancel Remove" : "Remove"}
                    </Button>

                    <ErrorKeyItemCreate isRemoveMode={isRemoveMode}/>
                </ModalFooter>
            </>)}
        </Modal>
    )
}

export default ModalErrorKeys;